import { date } from 'yup';

import { i18nErrors } from 'i18n/i18nErrors';

export const yupFieldDate = () => date().nullable().typeError(() => i18nErrors('invalid_date'));
